import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { CameraTrap } from "@typings/entities/devices/cameraTrap";

async function getCameraTrapById(id: string): Promise<CameraTrap> {
  const response = await apiClient.get<CameraTrap>(
    apiPaths.devices.cameraTraps.getById(id),
  );
  return response.data;
}

export function useGetCameraTrapById(
  cameraTrapId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    cameraTrapId ? [`fetch-camera-trap-${cameraTrapId}`] : null,
    () => getCameraTrapById(cameraTrapId!),
    options,
  );
}
